import {Component} from 'react'

import Loader from '../../../../../../shared/components/Loader/Loader.jsx'

export default class ReviewLoading extends Component {
  render() {
    return <Loader visible={true}/>
  }
}
